import { render, staticRenderFns } from "./SiteEdit.vue?vue&type=template&id=3b883dc5&scoped=true"
import script from "./SiteEdit.vue?vue&type=script&lang=ts"
export * from "./SiteEdit.vue?vue&type=script&lang=ts"
import style0 from "./SiteEdit.vue?vue&type=style&index=0&id=3b883dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b883dc5",
  null
  
)

export default component.exports